<template>
  <div>
    <h3>
      {{ $t("text.welcome_to") }} : <span :style="{ 'color': myTheme.modalTextColor }">{{ selectedLocation.name }}</span>
    </h3>
    <div class="location-image">
      <el-image :src="selectedLocation.logo">
        <div slot="error" class="image-slot">
          <img class="photo" src="img/logo-error-200.png" />
        </div>
      </el-image>
    </div>
    <div class="location-details">
      <ul>
        <li>
          <span><i class="k-icon-location"></i> {{ $t("text.address") }} :</span>
          <a href="#">{{
            generateFromatedAddress(selectedLocation.address, false)
          }}</a>
        </li>
        <li>
          <span><i class="k-icon-phone"></i> {{ $t("text.phone") }} :</span>
          <a href="javascript:;">{{ selectedLocation.telephone }}</a>
        </li>
        <li>
          <span><i class="k-icon-at"></i> {{ $t("text.mail") }} :</span>
          <a :href="'mailto:' + selectedLocation.email">{{
            selectedLocation.email
          }}</a>
        </li>
      </ul>
    </div>
    <el-divider v-if="openTimesInfo"></el-divider>
    <div class="box-widget-item fl-wrap" v-if="openTimesInfo">
      <div class="box-widget-item-header">
        <h3>{{ $t("text.working_hours") }} :</h3>
      </div>
      <div class="box-widget opening-hours">
        <div class="box-widget-content">
          <span class="current-status">
            <i class="k-icon-preptime"></i>
            <span class="status " :class="{ open: openTimesInfo.open, closed: !openTimesInfo.open }">
              {{ openTimesInfo.status }}</span>
            - {{ openTimesInfo.todayTime }} ({{ $t("text.today") }})
          </span>
          <div class="btn-group">
            <n-radio-button v-if="selectedLocation.orderSetting.offer_collection"
              :styleClass="myTheme.standardRadioButton" v-model="timingType" :label="ORDER_TYPE.Collection.id">
              {{ $t("button.collection") }}
            </n-radio-button>
            <n-radio-button v-if="selectedLocation.orderSetting.offer_delivery" :styleClass="myTheme.standardRadioButton"
              v-model="timingType" :label="ORDER_TYPE.Delivery.id">
              {{ $t("button.delivery") }}
            </n-radio-button>
            <n-radio-button v-if="selectedLocation.orderSetting.offer_tableordering"
              :styleClass="myTheme.standardRadioButton" v-model="timingType" :label="ORDER_TYPE.Table.id">
              {{ $t("button.table") }}
            </n-radio-button>
          </div>
          <ul v-for="(item, index) in openTimesInfo.openingRedable" :key="index">
            <li>
              <span class="opening-hours-day" :class="{ today: item.isToday }">{{ $t(`days.${item.name.toLowerCase()}`)
              }}</span><span class="opening-hours-time" :class="{ today: item.isToday }"><span>{{ item.time
}}</span></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-divider v-if="selectedLocation.hygiene_rating"></el-divider>
    <div class="box-widget-item fl-wrap" v-if="selectedLocation.hygiene_rating">
      <div class="box-widget-item-header">
        <h3>{{ $t("message.food_hygiene_details_title") }} :</h3>
      </div>
      <div class="box-widget food-hygiene">
        <p>{{ $t("message.food_hygiene_details_message") }}</p>
        <!--selectedLocation.hygiene_rating.rating_key-->
        <el-image class="" :src="getDietayImage(selectedLocation.hygiene_rating.rating_key)">
          <div slot="placeholder" class="image-slot">
            <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"></i>
          </div>
        </el-image>

      </div>

    </div>
  </div>
</template>
<script>
import { ORDER_TYPE } from "@/utilities/enums";
import { getOpeningTimesReadable, generateFromatedAddress } from "@/utilities/helper";
import { mapActions } from "vuex";
import {
  RadioButton,
} from "@/components";
export default {
  name: "location-infos",
  components: {
    [RadioButton.name]: RadioButton,
  },
  computed: {
    openTimesInfo() {
      if (!this.isMounted || !this.selectedLocation) return null;
      return getOpeningTimesReadable(
        this.selectedLocation.openingHours.open,
        this.selectedLocation.openingHoursReadable,
        this.timingType
      );
    }
  },
  data() {
    return {
      ORDER_TYPE,
      generateFromatedAddress,
      isMounted: false,
      shown: false,
      timingType: ORDER_TYPE.Collection.id
    };
  },
  methods: {
    ...mapActions('locationStore', ["fetchLocationReviews"]),
    getDietayImage(rating_key) {
      return `img/dietary/${rating_key}.jpg`
    }
  },
  created() {

    if (this.isLocationEmpty()) this.$router.push("/");

    this.fetchLocationReviews(this.selectedLocation.id);

    this.timingType = this.selectedLocation.orderSetting.offer_collection ? ORDER_TYPE.Collection.id
      : this.selectedLocation.orderSetting.offer_delivery ? ORDER_TYPE.Delivery.id :
        this.selectedLocation.orderSetting.offer_tableordering ? ORDER_TYPE.Table.id : null;
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>
<style>
.opening-hours .btn-group {
  width: 100%;
  margin-bottom: 15px;
}
</style>
